import BuildVariables from '~/util/buildVariables';

export default {
    isLocal() {
        const hostname = window.location.hostname;
        return !BuildVariables.isProductionEnv() || hostname === 'localhost' || hostname === '127.0.0.1';
    }
};
